import React from 'react';
import Container from 'legacy/common/components/layout/Container';

const OfferListSkeleton: React.FC = () => (
  <Container>
    <div className="animate-pulse pt-[90px] md:pt-[180px] -mt-[90px] pb-20 md:w-[630px] md:mx-auto">
      <div className="flex flex-col space-y-2 w-full">
        <div className="h-8 bg-gray-200 rounded w-1/6 mb-4" />
        <div className="h-60 bg-gray-200 rounded w-5/6 rounded-xl" />
        <div className="h-60 bg-gray-200 rounded w-5/6 rounded-xl" />

        <div className="h-8 bg-gray-200 rounded w-1/6 mb-4 mt-2" />
        <div className="h-60 bg-gray-200 rounded w-5/6 rounded-xl" />
      </div>
    </div>
  </Container>
);

export default OfferListSkeleton;
